/**
 * Les routes de formulaire RÉELLEMENT déclarées dans App.tsx.
 *
 * Pourquoi ce fichier existe : navigateBasedOnTitle (VisasScreen) vise 79 routes
 * distinctes alors qu'App.tsx n'en déclare que 58 (hors /formulaire_creation_voyageur,
 * jamais émis par allerVers), et il n'existait aucune route catch-all.
 * 20 destinations mènent donc encore à une page blanche, dont le repli
 * '/formulaire_template' du dernier `else` — elles n'ont AUCUN composant dans
 * src/formulaires/, le dialogue « à monter avec un conseiller » y dit donc vrai.
 *
 * Attention à la casse : cinq routes prennent une majuscule.
 * À tenir à jour si une route est ajoutée dans App.tsx.
 */
export const ROUTES_DECLAREES: ReadonlySet<string> = new Set([
  '/classique_formulaire_Chine',
  '/classique_formulaire_Ethiopie',
  '/classique_formulaire_Liberia',
  '/classique_formulaire_Nepal',
  '/classique_formulaire_Soudan',
  '/classique_formulaire_arabie_saoudite',
  '/classique_formulaire_bangladesh',
  '/classique_formulaire_centrafrique',
  '/classique_formulaire_congo_brazzaville',
  '/classique_formulaire_congo_kinshasa',
  '/classique_formulaire_coree_du_sud',
  '/classique_formulaire_gabon',
  '/classique_formulaire_ghana',
  '/classique_formulaire_guinee_bissau',
  '/classique_formulaire_guinee_equatoriale',
  '/classique_formulaire_liban',
  '/classique_formulaire_madagascar',
  '/classique_formulaire_nigeria',
  '/formulaire_angola',
  '/formulaire_arabie_saoudite',
  '/formulaire_australie',
  '/formulaire_bahrein',
  '/formulaire_benin',
  '/formulaire_cambodge',
  '/formulaire_cameroun',
  '/formulaire_canada',
  '/formulaire_cap_vert',
  '/formulaire_chine_ecard',
  '/formulaire_coree_du_sud',
  '/formulaire_cote_d_ivoire',
  '/formulaire_djibouti',
  '/formulaire_dubai',
  '/formulaire_egypte',
  '/formulaire_ethiopie',
  '/formulaire_guinee',
  '/formulaire_inde',
  '/formulaire_inde_ecard',
  '/formulaire_indonesie',
  '/formulaire_jordanie',
  '/formulaire_kenya',
  '/formulaire_koweit',
  '/formulaire_laos',
  '/formulaire_madagascar',
  '/formulaire_malaisie_ecard',
  '/formulaire_myanmar',
  '/formulaire_nigeria',
  '/formulaire_nouvelle_zelande',
  '/formulaire_oman',
  '/formulaire_ouganda',
  '/formulaire_papouasie_ng',
  '/formulaire_seychelles',
  '/formulaire_singapour_ecard',
  '/formulaire_sri_lanka',
  '/formulaire_tanzanie',
  '/formulaire_togo',
  '/formulaire_turquie',
  '/formulaire_uk',
  '/formulaire_usa',
  '/formulaire_vietnam',
]);

export const estRouteDeclaree = (route: string | null | undefined): boolean =>
  !!route && ROUTES_DECLAREES.has(route);
